// src/constants/ticketLayouts.js
// Default per-sub-event ticket layouts used for both on-screen tables and printing.

export const FALLBACK_LAYOUT = {
  columns: ['name', 'email', 'team', 'days', 'ticketCount'],
  sortBy: 'name',
  sortDir: 'asc',
};

// Keys match summary labels in eventSummary.byDayTable (see functions/eventSummaryCore.js EVENT_SUMMARY_ROW_ORDER).
export const DEFAULT_TICKET_LAYOUTS = {
  'High Altitude': {
    columns: ['name', 'ticketCount'],
    sortBy: 'name',
    sortDir: 'asc',
  },
  Jet: {
    // Jet tickets: keep it simple — no team or days columns.
    columns: ['name', 'email', 'ticketCount'],
    sortBy: 'name',
    sortDir: 'asc',
  },
  'Fury Lab': {
    // As requested: email, phone, jumps, tunnel (plus name and team/mentor for readability).
    columns: ['name', 'email', 'team', 'mentor', 'phone', 'jumps', 'tunnel', 'ticketCount'],
    sortBy: 'name',
    sortDir: 'asc',
  },
  'After Party': {
    // Same as Fury Lab.
    columns: ['name', 'email', 'team', 'mentor', 'phone', 'jumps', 'tunnel', 'ticketCount'],
    sortBy: 'name',
    sortDir: 'asc',
  },
  'Water Training (Thur)': {
    // As requested: email, phone, days only (plus name and team/mentor).
    columns: ['name', 'email', 'team', 'mentor', 'phone', 'days', 'ticketCount'],
    sortBy: 'name',
    sortDir: 'asc',
  },
  'Water Training (Fri)': {
    columns: ['name', 'email', 'team', 'mentor', 'phone', 'days', 'ticketCount'],
    sortBy: 'name',
    sortDir: 'asc',
  },
  'Canopy Thursday': {
    columns: ['name', 'email', 'team', 'mentor', 'phone', 'jumps', 'days', 'ticketCount'],
    sortBy: 'name',
    sortDir: 'asc',
  },
  'Canopy Friday': {
    columns: ['name', 'email', 'team', 'mentor', 'phone', 'jumps', 'days', 'ticketCount'],
    sortBy: 'name',
    sortDir: 'asc',
  },
};

